import { defineStore } from 'pinia'
import axios from 'axios'
import { computed, ref, onMounted } from 'vue'
import { usePage } from '@inertiajs/vue3'

export const useMainStore = defineStore('main', () => {

    const page = usePage()
    const loginUser = page.props.auth.user
    const notificationCount = 1

    const mobileSearchMode =  "list" // initial mode
    let screenWidth = ref(window.innerWidth) // capture screen width
    let isMobileViewport = ref(window.innerWidth <= 767) // check if mobile viewport

    const isFieldFocusRegistered = ref(false)

    const clients = ref([])
    const history = ref([])
    const selectedQuestionCompanyType = ref(null)

    function resized(newScreenWidth) {
        screenWidth.value = newScreenWidth
        isMobileViewport.value = newScreenWidth <= 767
    }

    function setSelectedQuestionCompanyType(companyType) {
        selectedQuestionCompanyType.value = companyType
    }

    function clearSelectedQuestionCompanyType() {
        selectedQuestionCompanyType.value = null
    }

    return {
        notificationCount,
        isFieldFocusRegistered,
        clients,
        history,
        mobileSearchMode,
        screenWidth,
        isMobileViewport,
        resized,
        selectedQuestionCompanyType,
        setSelectedQuestionCompanyType,
        clearSelectedQuestionCompanyType,
    }
})
